export default __webpack_public_path__ + "static/media/ic-art-single-dumbell.270a3641.svg";